/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Renders_TitleInputs */

const en_directory_ai_tools_renders_title = /** @type {(inputs: Directory_Ai_Tools_Renders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your videos`)
};

const zh_directory_ai_tools_renders_title = /** @type {(inputs: Directory_Ai_Tools_Renders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的视频`)
};

/**
* | output |
* | --- |
* | "Your videos" |
*
* @param {Directory_Ai_Tools_Renders_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_renders_title = /** @type {((inputs?: Directory_Ai_Tools_Renders_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Renders_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_renders_title(inputs)
	return zh_directory_ai_tools_renders_title(inputs)
});
export { directory_ai_tools_renders_title as "directory.ai_tools.renders.title" }